import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
import { DatePickerDate, DateVariant, PickersDayProps, Stack } from '@lyearn/ui';
import InlineDatePicker from '@/components/InlineDatePicker';

import CalendarDay from './CalendarDay';
import { inlineDatePickerStyles } from './style';
import { DateSelectorProps } from './types';

function DateSelector({
  selectedCalendarDate,
  calendarDaysWithActivity,
  setStartingCalendarMonth,
  setSelectedCalendarDate,
}: DateSelectorProps) {
  const onMonthChange = useCallback(
    (date: DatePickerDate) => date && setStartingCalendarMonth(date),
    [setStartingCalendarMonth],
  );

  const onChange = useCallback(
    (date: any) => {
      if (date) {
        date.setHours(0, 0, 0, 0);
        setSelectedCalendarDate(date);
      }
    },
    [setSelectedCalendarDate],
  );

  const renderDay = (
    day: DatePickerDate,
    selectedDates: DatePickerDate[],
    pickersDayProps: PickersDayProps<DatePickerDate>,
  ) => {
    return (
      <CalendarDay
        daysWithActivity={calendarDaysWithActivity}
        pickersDayProps={pickersDayProps}
        selectedDate={selectedCalendarDate}
      />
    );
  };

  return (
    <Stack className={cn(inlineDatePickerStyles)}>
      <InlineDatePicker
        pickerProps={{
          onMonthChange,
          variant: DateVariant.Date,
          onChange,
          selectedTime: selectedCalendarDate,
          renderDay,
        }}
        showActionButtons={false}
        showSelectedTime={false}
      />
    </Stack>
  );
}

export default React.memo(DateSelector);
